export const CREATE_CUSTOMER = "CREATE_CUSTOMER";

export const createCustomer = (data) => {
    return {
        type: CREATE_CUSTOMER,
        payload: data,
    };
};
